/* eslint-disable no-console */
import { get, getOr, map, each, toString } from 'lodash/fp';
import AnalyticsConstants from '../../../analytics/constants';
import { getChoiceValue, getChoicePrice } from '../../../helpers/getChoiceValue';
import config from '../../../helpers/config';

const primaryCategory = getOr(AnalyticsConstants.PrimaryCategories.ButtonSubmission, 'thdAnalyticsEvent.category.primaryCategory', window);
const eventName = getOr(AnalyticsConstants.EventNames.CartAdd, 'thdAnalyticsEvent.eventInfo.eventName', window);

const mapItemProduct = (itemProduct) => {
  const item = {
    // option.color: getAttributeValue('color')(itemProduct),
    productInfo: {
      sku: toString(get('skuNumber')(itemProduct)),
      option: {
        color: getChoiceValue('color')(itemProduct),
        price: toString(getChoicePrice('color')(itemProduct)),
      },
      productName: get('productName')(itemProduct),
      productCategory: get('productCategory')(itemProduct),
      manufacturer: get('vendor')(itemProduct),
      productType: get('productType')(itemProduct),
    },
    quantity: '1',
    price: {
      basePrice: toString(get('retail')(itemProduct)),
    },
  };
  return item;
};

const getAnalyticsItemsFromProducts = (selectedProducts) => {
  const itemProducts = map('itemProduct')(selectedProducts);
  const items = map(ip => mapItemProduct(ip))(itemProducts);
  return items;
};

const getAnalyticsItemForService = (job) => {
  const serviceType = getOr('', 'serviceType')(job);
  if (serviceType.toUpperCase() !== 'I') {
    return null;
  }
  const item = {
    // option.color: getAttributeValue('color')(itemProduct),
    productInfo: {
      sku: toString(config.wellKnownProductIds.mandi[get('serviceType', job)]),
      option: {
        color: null,
        price: null,
      },
      productName: 'install',
      productCategory: null,
      manufacturer: null,
      productType: 'service',
    },
    quantity: '1',
    price: {
      basePrice: toString(get('pricingResult.retail')(job)),
    },
  };
  return item;
};

const sendAnalytics = (items) => {
  const thdAnalyticsEvent = {
    category: {
      primaryCategory,
    },
    eventInfo: {
      eventName,
    },
    item: items,
  };
  // eslint-disable-next-line no-underscore-dangle, no-undef
  if (window._T && typeof (_T.sendEventDataToAnalytics) !== 'undefined') {
    // eslint-disable-next-line no-undef
    if (_T.sendEventDataToAnalytics) {
      console.log('analyticsEvent', thdAnalyticsEvent);
      // eslint-disable-next-line no-undef
      _T.sendEventDataToAnalytics(thdAnalyticsEvent);
    }
  }
};

export default (cartingOptions) => {
  const items = [];
  const selectedProducts = get('selectedProducts')(cartingOptions);
  const productAnalyticsItems = getAnalyticsItemsFromProducts(selectedProducts);
  each(i => items.push(i))(productAnalyticsItems);
  const productOnlyItems = get('productOnlyItems')(cartingOptions);
  const productOnlyAnalyticsItems = getAnalyticsItemsFromProducts(productOnlyItems);
  each(i => items.push(i))(productOnlyAnalyticsItems);
  const job = get('job')(cartingOptions);
  const serviceItem = getAnalyticsItemForService(job);
  if (serviceItem) {
    items.push(serviceItem);
  }
  sendAnalytics(items);
};
